import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logError } from '../utils/logging';
import { sttApi } from '../api/sttApi'; // Import stt client

export const useUserData = () => {
  const navigate = useNavigate();

  
  const [userData, setUserData] = useState(null);
  const [availablePlans, setAvailablePlans] = useState([]);
  const [topUpPackages, setTopUpPackages] = useState([]);
  const [recentJobs, setRecentJobs] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      const [statsData, productsData, jobsData] = await Promise.all([
        sttApi.getUserStats(),
        sttApi.getProducts(),
        sttApi.getUserRecentJobs(50), // Zvýšeno z 5 na 50 pro zobrazení všech jobů
      ]);

      setUserData(statsData);
      setAvailablePlans(productsData.filter(p => p.product_type === 'subscription'));
      setTopUpPackages(productsData.filter(p => p.product_type === 'topup'));
      setRecentJobs(jobsData.jobs || []);

    } catch (err) {
      logError(err, { context: 'useUserData fetchData' });
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    const userEmail = localStorage.getItem('userEmail');
    if (!userEmail) {
      navigate('/login');
      return;
    }
    fetchData();
  }, [fetchData, navigate]);

  return { userData, availablePlans, topUpPackages, recentJobs, error, loading, refetchData: fetchData };
};
